import { SocialGroup, ShareMethod } from 'interfaces/share'

export const SOCIAL_REWARD_AMOUNT = 5

export const SOCIAL_MEDIA_URLS: Record<SocialGroup, string> = {
  facebook: 'https://www.facebook.com/StatusMoneyUSA',
  twitter: 'https://twitter.com/StatusMoneyUSA',
  linkedin: 'https://www.linkedin.com/company/24428849/',
}

export const APP_STORE_URL = 'https://itunes.apple.com/us/app/status-money-financial-manager/id1427699722?mt=8'
export const PLAY_MARKET_URL = 'https://play.google.com/store/apps/details?id=com.statusmoney'

export const SHARE_URLS: Record<ShareMethod, string | null> = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://twitter.com/intent/tweet',
  email: 'mailto:',
  native: null,
}

export const SHARE_POPUP_PARAMS = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=420, toolbar=0, status=0'
